export default __webpack_public_path__ + "static/media/how to care for your bra.58a97238.png";